import { useCalendars } from '../../../../hooks/queries/useCalendars';
import AdminCalendars from './components/AdminCalendars';

export function AppAdminCalendarConfig() {
    const { data: calendars } = useCalendars({ suspense: false });
    return <>{calendars && <AdminCalendars calendars={calendars} />}</>;
}
